import { render, staticRenderFns } from "./PlanEditComplete.vue?vue&type=template&id=284adaa5"
import script from "./PlanEditComplete.vue?vue&type=script&lang=js"
export * from "./PlanEditComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports